(function () {
  angular.module("akitabox.ui.dialogs.document.thumbnailFit", [
    "ngMaterial",
    "akitabox.core.constants",
    "akitabox.core.services.building",
  ]);
})();
